<div class="overview-page">
    <div class="overview-header">
        <div class="overview-header__title">
            <app-heading [text]="texts.page_title" [level]="'h1'"></app-heading>
            <app-risk-score-widget></app-risk-score-widget>
        </div>
        <div class="overview-header__buttons">
            <a [routerLink]="generate_report_path" target="_blank">
                <app-ui-button [variant]="'secondary'" [size]="'small'" [label]="texts.download_report"
                               [leftIcon]="IconsEnum.report">
                </app-ui-button>
                <!--START Remove after POC -->
                <app-ui-button *appFeatureFlag="FeatureFlags.pocFlag" variant="primary" size="small" label="Hello Feature flags"></app-ui-button>
                <!--END Remove after POC -->
            </a>
        </div>
    </div>
    @if (showIcpLicenseExpiredMessage()) {
      <app-message-block
        [type]="toasterType.Warning"
        [message]="this.dashboardTexts.icp_license_expired_notification"
        [dismissible]="true"
        [link]="icpsLink"
        (dismissClick)="saveDismissToStorage()"
      ></app-message-block>
    }
    <app-main-kpi-wrapper class="overview-page__kpi-wrapper"></app-main-kpi-wrapper>
    <app-whats-new-kpi-wrapper class="overview-page__kpi-wrapper"></app-whats-new-kpi-wrapper>
        <div class="chart-container">
          <div class="left-charts">
            <app-ui-pie-chart-card [title]="this.pieChartByType.title"
                                   [dropdownOptions]="this.pieChartByType.selectOptions"
                                   [queryConfig]="this.pieChartByType.queryTransform"
                                   [isClickable]="!isEm()">
            </app-ui-pie-chart-card>

            <app-ui-pie-chart-card [title]="this.pieChartByCriticality.title"
                                   [dropdownOptions]="this.pieChartByCriticality.selectOptions"
                                   [queryConfig]="this.pieChartByCriticality.queryTransform"
                                   [isClickable]="!isEm()"
                                   [transparentIconColor]="true"
                                   ></app-ui-pie-chart-card>
          </div>
            <app-table-card
                    [title]="this.tableCardSettings.texts.title"
                    [buttonLabel]="this.tableCardSettings.texts.button"
                    [buttonIcon]="this.tableCardSettings.buttonIcon"
                    [buttonNavigateTo]="this.tableCardSettings.buttonNavigateTo"
                    [gridOptions]="this.tableCardSettings.gridOptions"
            ></app-table-card>

        </div>

</div>
